/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './user-view.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../sidenav/sidenav.component.ngfactory';
import * as i3 from '../../../../src/app/sidenav/sidenav.component';
import * as i4 from '../../../../src/app/user-view/user-view.component';
import * as i5 from '../topnav/topnav.component.ngfactory';
import * as i6 from '../../../../src/app/topnav/topnav.component';
import * as i7 from '../../../../src/app/core/vex-dialog.service';
import * as i8 from '@angular/router';
import * as i9 from '../footer/footer.component.ngfactory';
import * as i10 from '../../../../src/app/footer/footer.component';
const styles_UserViewComponent:any[] = [i0.styles];
export const RenderType_UserViewComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_UserViewComponent,data:{}});
export function View_UserViewComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'aside',[['class',
      'sidenav']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-sidenav',([] as any[]),
          (null as any),(null as any),(null as any),i2.View_SidenavComponent_0,i2.RenderType_SidenavComponent)),
      i1.ɵdid(4898816,(null as any),0,i3.SidenavComponent,([] as any[]),{color:[0,
          'color']},(null as any)),(_l()(),i1.ɵeld(0,(null as any),(null as any),10,
          'section',[['class','main']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'nav',[['class',
          'topnav']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-topnav',([] as any[]),
          (null as any),[[(null as any),'alwaysShowSidenavChange'],[(null as any),
              'navColorChange'],[(null as any),'boxedChange']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i4.UserViewComponent = _v.component;
            if (('alwaysShowSidenavChange' === en)) {
              const pd_0:any = ((<any>(_co.alwaysShowSidenav = $event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('navColorChange' === en)) {
              const pd_1:any = ((<any>(_co.navColor = $event)) !== false);
              ad = (pd_1 && ad);
            }
            if (('boxedChange' === en)) {
              const pd_2:any = ((<any>(_co.boxed = $event)) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },i5.View_TopnavComponent_0,i5.RenderType_TopnavComponent)),i1.ɵdid(4767744,
          (null as any),0,i6.TopnavComponent,[i7.VexDialogService],{alwaysShowSidenav:[0,
              'alwaysShowSidenav'],navColor:[1,'navColor'],boxed:[2,'boxed']},{alwaysShowSidenavChange:'alwaysShowSidenavChange',
              navColorChange:'navColorChange',boxedChange:'boxedChange'}),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),6,'section',[['class','content-area']],
              (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),2,'section',[['class','content-area__content']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(16777216,(null as any),(null as any),1,'router-outlet',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(212992,(null as any),0,i8.RouterOutlet,[i8.ChildrenOutletContexts,i1.ViewContainerRef,
          i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],(null as any),
          (null as any)),(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'footer',
          [['class','content-area__footer']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'admin-footer',([] as any[]),(null as any),(null as any),(null as any),
          i9.View_FooterComponent_0,i9.RenderType_FooterComponent)),i1.ɵdid(49152,
          (null as any),0,i10.FooterComponent,([] as any[]),(null as any),(null as any))],
      (_ck,_v) => {
        var _co:i4.UserViewComponent = _v.component;
        const currVal_0:any = _co.navColor;
        _ck(_v,2,0,currVal_0);
        const currVal_1:any = _co.alwaysShowSidenav;
        const currVal_2:any = _co.navColor;
        const currVal_3:any = _co.boxed;
        _ck(_v,6,0,currVal_1,currVal_2,currVal_3);
        _ck(_v,10,0);
      },(null as any));
}
export function View_UserViewComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'ng-component',
      ([] as any[]),[[2,'always-show-sidenav',(null as any)],[2,'boxed',(null as any)]],
      (null as any),(null as any),View_UserViewComponent_0,RenderType_UserViewComponent)),
      i1.ɵdid(49152,(null as any),0,i4.UserViewComponent,([] as any[]),(null as any),
          (null as any))],(null as any),(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).alwaysShowSidenav;
    const currVal_1:any = i1.ɵnov(_v,1).boxed;
    _ck(_v,0,0,currVal_0,currVal_1);
  });
}
export const UserViewComponentNgFactory:i1.ComponentFactory<i4.UserViewComponent> = i1.ɵccf('ng-component',
    i4.UserViewComponent,View_UserViewComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvdXNlci12aWV3L3VzZXItdmlldy5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC91c2VyLXZpZXcvdXNlci12aWV3LmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvdXNlci12aWV3L3VzZXItdmlldy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvdXNlci12aWV3L3VzZXItdmlldy5jb21wb25lbnQudHMuVXNlclZpZXdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YXNpZGUgY2xhc3M9XCJzaWRlbmF2XCI+PGFkbWluLXNpZGVuYXYgW2NvbG9yXT1cIm5hdkNvbG9yXCI+PC9hZG1pbi1zaWRlbmF2PjwvYXNpZGU+PHNlY3Rpb24gY2xhc3M9XCJtYWluXCI+PG5hdiBjbGFzcz1cInRvcG5hdlwiPjxhZG1pbi10b3BuYXYgWyhhbHdheXNTaG93U2lkZW5hdildPVwiYWx3YXlzU2hvd1NpZGVuYXZcIiBbKG5hdkNvbG9yKV09XCJuYXZDb2xvclwiIFsoYm94ZWQpXT1cImJveGVkXCI+PC9hZG1pbi10b3BuYXY+PC9uYXY+PHNlY3Rpb24gY2xhc3M9XCJjb250ZW50LWFyZWFcIj48c2VjdGlvbiBjbGFzcz1cImNvbnRlbnQtYXJlYV9fY29udGVudFwiPjxyb3V0ZXItb3V0bGV0Pjwvcm91dGVyLW91dGxldD48L3NlY3Rpb24+PGZvb3RlciBjbGFzcz1cImNvbnRlbnQtYXJlYV9fZm9vdGVyXCI+PGFkbWluLWZvb3Rlcj48L2FkbWluLWZvb3Rlcj48L2Zvb3Rlcj48L3NlY3Rpb24+PC9zZWN0aW9uPiIsIjxuZy1jb21wb25lbnQ+PC9uZy1jb21wb25lbnQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtNQUF1QjtVQUFBO2FBQUE7VUFBQSx5QkFBMEQ7VUFBQTtVQUFBLGdCQUFzQjtVQUFBO01BQW9CO1VBQUE7Y0FBQTtZQUFBO1lBQUE7WUFBYztjQUFBO2NBQUE7WUFBQTtZQUEwQztjQUFBO2NBQUE7WUFBQTtZQUF3QjtjQUFBO2NBQUE7WUFBQTtZQUFoRjtVQUFBLG1FQUFBO1VBQUE7Y0FBQTtjQUFBLDREQUF1SDtpQkFBQTtjQUFBO01BQThCO1VBQUE7TUFBdUM7VUFBQTthQUFBO3NDQUFBO1VBQUEsZUFBeUM7VUFBQTtVQUFBLDhCQUFxQztVQUFBO2lFQUFBLFVBQUE7VUFBQTs7O1FBQS9WO1FBQWYsV0FBZSxTQUFmO1FBQWtIO1FBQTBDO1FBQXdCO1FBQWhGLFdBQWMsVUFBMEMsVUFBd0IsU0FBaEY7UUFBNEw7Ozs7b0JDQXZUO01BQUE7TUFBQTthQUFBO1VBQUE7SUFBQTtJQUFBO0lBQUEsV0FBQSxtQkFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./$$_gendir/src/app/user-view/user-view.component.ngfactory.ts